var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Name=Arrow-Right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2483 7.19614C12.4643 6.99183 12.7869 6.94506 13.0514 7.06559L13.1617 7.12886L13.2457 7.19646L17.7944 11.5189C18.0103 11.7236 18.0601 12.039 17.9251 12.3044L17.8658 12.4013L17.795 12.4811L13.2461 16.8037C12.9701 17.0654 12.5246 17.0654 12.2484 16.8036C12.0305 16.5964 11.9803 16.2832 12.1172 16.018L12.1774 15.9211L12.2485 15.8416L16.2904 11.9991L12.2481 8.15817C12.0247 7.94634 11.98 7.62731 12.1142 7.37251L12.1729 7.28031L12.2483 7.19614ZM6.2096 7.19614C6.42562 6.99183 6.74823 6.94506 7.01269 7.06559L7.10881 7.11864L7.20701 7.19646L11.7557 11.5189C11.9716 11.7236 12.0214 12.039 11.8864 12.3044L11.8271 12.4013L11.7563 12.4811L7.20735 16.8037C6.93135 17.0654 6.48593 17.0654 6.20975 16.8036C5.99179 16.5964 5.94159 16.2832 6.07852 16.018L6.13868 15.9211L6.20976 15.8416L10.2524 12L6.20942 8.15817C5.98602 7.94634 5.94133 7.62731 6.07547 7.37251L6.13415 7.28031L6.2096 7.19614Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.ff5e8b5bc27b54684cd9c7341f86a75e.svg";
export { ForwardRef as ReactComponent };